import * as o from "react";
import e from "../lib/IconBase.es.js";
import r from "../defs/Stack.es.js";
const t = o.forwardRef((a, c) => /* @__PURE__ */ o.createElement(e, { ref: c, ...a, weights: r }));
t.displayName = "StackIcon";
const n = t;
export {
  n as Stack,
  t as StackIcon
};
